import { integer } from '@/utils/rules/customRules';
// return warning msg
export const commonValidMobile = ({ mobileCountry, mobile, isRequired = false }) => {
    if (mobile === undefined && mobileCountry === undefined) return;
    let msg = '';
    if (!isRequired && mobile === '' && mobileCountry === '') {
        msg = '';
    } else if (isRequired && mobile === '') {
        msg = '請輸入行動電話';
    } else {
        if (integer(mobile.trim())) {
            msg = integer(mobile.trim(), '行動電話請輸入數字');
        } else if ((!mobileCountry || mobileCountry === '') && mobile.length > 0) {
            msg = '請選擇國碼';
        } else if (mobileCountry && mobile?.length === 0) {
            msg = '請輸入行動電話';
        } else if (mobileCountry === '886') {
            if (!/^09\d{8}$/.test(mobile)) {
                msg = '輸入格式為09XXXXXXXX';
            }
        } else if (
            (mobileCountry !== '886' && /^09+/.test(mobile)) ||
            mobile.length > 11 ||
            mobile.length < 7
        ) {
            msg = '請輸入有效之行動電話';
        }
    }
    return msg;
};

/** validate 電話號碼 */
export const commonValidateTel = ({ telAreaCode, tel, telExt, isRequired = false }) => {
    if (telAreaCode === undefined && tel === undefined && telExt === undefined) {
        return;
    }
    let msg = '';
    const allPhone = telAreaCode + tel + telExt;
    if (isRequired && allPhone.trim() === '') {
        msg = '請輸入電話號碼';
    } else if (allPhone.trim() !== '') {
        if (integer(allPhone.trim())) {
            msg = integer(telAreaCode.trim(), '區碼請輸入數字') || integer(tel.trim(), '電話號碼請輸入數字') || integer(telExt.trim(), '分機請輸入數字');
        } else if (tel.length === 0) {
            msg = '請輸入電話號碼';
        } else if (tel.length < 6) {
            msg = '請輸入有效之電話號碼';
        } else if (telAreaCode === '02' && tel.length !== 8) {
            msg = '請輸入8碼之電話號碼';
        } else if (!telAreaCode || !telAreaCode.length) {
            msg = '請輸入區碼';
        } else if (telAreaCode.length < 2 || telAreaCode.length > 4) {
            msg = '請輸入有效之區碼';
        } else if (telExt.length > 6) {
            msg = '分機至多接受6字元';
        }
    }
    return msg;
};
